<!--
 日期选择组件
 -->
<template>
  <span>
    <DatePicker @on-change="change" :options="options" v-model="value" :placeholder="placeholder" :type="type" :format="format" :size="size" :transfer="true" :style="styles"></DatePicker>
  </span>
</template>
<script>
  export default {
    props:{
      options:{
        type:Object,
        default:()=>{},
      },
      value:{
        type:String,
        default:''
      },
      type:{
        type:String,
        default:'date'
      },
      placeholder:{
        type:String,
        default:''
      },
      format:{
        type:String,
        default:'yyyy-MM-dd'
      },
      size:{
        type:String,
        default:'default'
      },
      styles:{
        type:String,
        default:''
      }

    },
    data(){
      return{
      }
    },
    methods:{
      change(val){
        this.value = val;
        this.$emit('input',this.value);
        this.$emit('on-change');
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/public/iview/DateSelect.vue